import React from "react";
import { Button, Heading, Input } from "@chakra-ui/react";

const Filter = ({ filteredName, handleFilteredName, toggleSearch }) => {
  return (
    <>
      <Heading as="h2" mb="30px">
        Search
      </Heading>
      <Input
        value={filteredName}
        onChange={handleFilteredName}
        mb="10px"
      ></Input>
      <Button mb="10px" onClick={toggleSearch} colorScheme="purple">
        Toggle Search
      </Button>
    </>
  );
};

export default Filter;
